import { Alert, AlertIcon, AlertText } from "@/components/ui/alert";
import { VStack } from "@/components/ui/vstack";
import { Info } from "lucide-react-native";
import { Link as ExpoLink } from "expo-router";
import * as WebBrowser from "expo-web-browser";
import { Platform } from "react-native";
import { ComponentPropsWithoutRef } from "react";

const helpLink = "https://help.gotips.co/guides/generating-printing-qr/";

export function QRViewGuideAlert(props: ComponentPropsWithoutRef<typeof Alert>) {
  return (
    <ExpoLink
      href={helpLink}
      target="_blank"
      onPress={(e) => {
        if (Platform.OS === "android" || Platform.OS === "ios") {
          e.preventDefault();
          WebBrowser.openBrowserAsync(helpLink);
        }
      }}
    >
      <Alert action="info" variant="solid" {...props}>
        <AlertIcon as={Info} className="min-w-5" />
        <VStack className="gap-0 flex-1">
          <AlertText bold>
            How to print and place your QR code?
          </AlertText>
          <AlertText>
            <AlertText underline>See our guide</AlertText> on how to print it
            and where to place it for maximum visibility.
          </AlertText>
        </VStack>
      </Alert>
    </ExpoLink>
  );
}
